import React from 'react'
import moment from 'moment'
// 26 мая, 19:01

export default ({ name, text, created }) => (
  <div className='Comments__item'>
    <span className='Comments__date Label'>{moment(created).format('D MMMM, H:mm')}</span>
    <span className='Comments__name SubHead'>{name}</span>
    <p className='Comments__text Text'>{text}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Comments/Entry.jsx